import {FirstProduct} from "./assets/index";
import {SecondProduct} from "./assets/index";
import {ThirdProduct} from "./assets/index";


export const PRODUCTS = [
    {
        id: 1,
        productName: "Orchids",
        productDetail: "4 branches of orchids, 20 roses",
        price: 55,
        productImage: FirstProduct,
        detail: "Wrapped in a delicate pastel-hued paper and adorned with lush greenery, the Orchids bouquet exudes elegance and charm. The four branches of orchids, gracefully intermingled with twenty vibrant roses, create a stunning visual symphony that is sure to captivate the senses. Each bloom is carefully selected to ensure peak freshness and longevity, making this bouquet a perfect gift for any special occasion.",
    },
    {
        id: 2,
        productName: "Rose",
        productDetail:"Daisy, 3 roses, gerbera and seasonal flowers",
        price: 40,
        productImage: SecondProduct,
        detail: "Embrace the beauty of nature with our exquisite Rose bouquet. In addition to the three radiant roses, this arrangement features delicate daisies, vibrant gerbera daisies, and a selection of seasonal blooms. The harmonious blend of colors and textures creates a captivating bouquet that is bound to convey your heartfelt sentiments. Each flower is handpicked to ensure a perfect balance of freshness and longevity, making this bouquet a cherished gift for any occasion.",
    },
    {
        id: 3,
        productName: "Daisy",
        productDetail:"4 roses, daisy, sweet william, Lavender",
        price: 35,
        productImage: ThirdProduct,
        detail: "Experience the joy of a garden in full bloom with our delightful Daisy bouquet. Alongside the charming daisies, this arrangement showcases the beauty of four resplendent roses, sweet william, and a touch of fragrant lavender. The combination of these blooms creates a captivating visual symphony that is sure to brighten any space. Every flower is carefully selected to ensure optimal freshness and longevity, making this bouquet a cherished gift for nature enthusiasts and flower lovers alike.",
    },
    
   
    
]